/**
 * CORE-1791 (возврат QA 23.10) — правила композера треда, которые раньше
 * зависели от ширины окна, а не от того, где тред стоит. Чистые функции:
 * тред тянет за собой пол-приложения, а эти решения проверяются тестом.
 */

/**
 * Поле с картинками эмодзи (DraftField) или прежнее текстовое.
 *
 * В разделе сообщений (/chats, веб) — всегда: в макете v3 эмодзи из палитры
 * встаёт в черновик картинкой 28 на любой ширине, а на desktop поле показывало
 * `Спасибо :agape_3:` текстом. Вне раздела — как решено в CORE-1730: картинки
 * только в телефонном композере (<768), на desktop прежний TextInput.
 */
export function composerUsesDraftField({ section, mobileComposer }: { section: boolean; mobileComposer: boolean }): boolean {
  return section || mobileComposer;
}

/**
 * Тип голосового для загрузки — без параметров кодека.
 *
 * Chrome пишет `audio/webm;codecs=opus`, а список допустимых типов (лимиты
 * вложений чат-сервиса и сервера) знает голое `audio/webm`: сравнение целиком
 * отклоняло запись «Такие файлы…» ещё до загрузки. Раньше параметр срезался
 * только в телефонном композере — и голосовое отклонялось на ширине, где
 * композер не телефонный (в разделе сообщений с CORE-1791 это 701–767, на
 * desktop — всегда). Для типа файла параметр кодека ничего не значит.
 */
export function voiceUploadMime(recordedMime: string | null | undefined): string {
  const bare = (recordedMime || '').split(';')[0].trim().toLowerCase();
  return bare || 'audio/webm';
}
